var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"70%","margin-left":"10%","margin-top":"30px"}},[_c('SearchMethodsDetail',{attrs:{"sepaMethods":this.$store.detailForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }